import { useNavigate } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { apiClient, getErrorMessage } from "@/features/shared";
import { SupplierForm } from "@/features/suppliers/supplier-form";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const CreateSupplier = () => {
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      await apiClient.post("suppliers", formData);
      navigate(-1);
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal membuat pemasok"));

      showSnackbar(
        getErrorMessage(error, "Gagal membuat pemasok")
      );
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Tambah Pemasok"
      breadcrumbs={[
        { title: "Pemasok", path: "/procurement/suppliers" },
        { title: "Tambah" },
      ]}
    >
      <SupplierForm
        onSubmit={handleSubmit}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
